module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-GOOGLEPLUS.449c9801.png";